import React from "react";

export const ProjectMenuSvg = ({ pathNames, color }) => {
  const svgColor = pathNames?.toLowerCase()?.includes("project")
    ? "#ffffff"
    : color
    ? color
    : "#667085";

  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        {/* Kanban board / columns icon for projects */}
        <rect
          x="2.5"
          y="2.5"
          width="15"
          height="15"
          rx="1.66667"
          stroke={svgColor}
          strokeWidth="1.8"
        />
        <path
          d="M7.5 2.5V17.5"
          stroke={svgColor}
          strokeWidth="1.8"
        />
        <path
          d="M12.5 2.5V17.5"
          stroke={svgColor}
          strokeWidth="1.8"
        />
        <path
          d="M4.16667 6.66667H6.25"
          stroke={svgColor}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M4.16667 9.58333H6.25"
          stroke={svgColor}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M9.16667 6.66667H11.25"
          stroke={svgColor}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M14.1667 6.66667H16.25"
          stroke={svgColor}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M14.1667 9.58333H16.25"
          stroke={svgColor}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M14.1667 12.5H16.25"
          stroke={svgColor}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
